module.exports = __webpack_public_path__ + "img/dz-home.67505bd1.png";